import { MarketSignalAlarm } from '@/modules/market-signals/model/market-signals/market-signal-alarm';
import styles from '@/modules/market-signals/components/market-signals/market-signals.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';

export default function MarketSignalAlarmBadge({ alarms }: { alarms?: MarketSignalAlarm[] }) {
  if (!alarms) return <></>;

  if (alarms.length === 0) return <></>;

  return (
    <span className={alarms.find(value => !value.acknowledged) ? styles.flashingAlarm : ''}>
      <FontAwesomeIcon icon={faBell} />
    </span>
  );
}
